const OutputHelper = {
    capitalization: {
        noCaps: 0,
        allCaps: 1,
        firstLetterCaps: 2,
    },
    boolOutputs: {
        0: ['ja', 'nee'],
        1: ['JA', 'NEE'],
        2: ['Ja', 'Nee'],
    },
    boolToYesNo(value, capitalization) {
        if (capitalization === undefined) {
            capitalization = 2;
        }
        const output = OutputHelper.boolOutputs[capitalization];
        return value ? output[0] : output[1];
    },
};

export default OutputHelper;
